import { BorderColorIcon } from './BorderColorIcon';

/**
 * author: Google
 * id CCD99C36-5D88-4696-8193-56F11C4B20A7
 * name border-color
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-color.svg
 * tags
 * - Color 
 * - Text / Content / Format 
 */
export const BorderColourIcon = BorderColorIcon;
export default BorderColourIcon